import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube } from "lucide-react";
import logoBranco from "@/assets/logo-indusport-rodape.png";
import { TikTokIcon, WhatsAppIcon, WHATSAPP_URL } from "./SocialIcons";

const socialLinks = [
  { href: "https://www.instagram.com/indusportriopreto/", label: "Instagram", renderIcon: () => <Instagram className="h-4 w-4" />, external: true },
  { href: "https://www.facebook.com/people/Indusport/61565866621971/", label: "Facebook", renderIcon: () => <Facebook className="h-4 w-4" />, external: true },
  { href: "https://www.tiktok.com/@indusportbr",          label: "TikTok",    renderIcon: () => <TikTokIcon size={16} />,           external: true },
  { href: "https://www.youtube.com/@Indusport",           label: "YouTube",   renderIcon: () => <Youtube className="h-4 w-4" />,   external: true },
  { href: WHATSAPP_URL,                                   label: "WhatsApp",  renderIcon: () => <WhatsAppIcon size={16} />,         external: true },
];

const Footer = () => {
  return (
    <footer className="bg-primary-gradient text-primary-foreground">
      <div className="container py-16 md:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4">
            <img src={logoBranco} alt="Indusport" className="h-20 w-auto" />
            <p className="text-sm leading-relaxed text-primary-foreground/70">
              Fábrica especialista em tintas, resinas e sistemas de pintura técnicos para construção, recuperação e pintura de pisos esportivos.
            </p>
            <p className="text-xs font-mono text-primary-foreground/50 uppercase tracking-widest">
              A Indusport não executa aplicação.
            </p>
            <div className="flex items-center gap-2 pt-1">
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  aria-label={link.label}
                  {...(link.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-foreground/10 text-primary-foreground/60 transition-all hover:bg-primary-foreground/20 hover:text-primary-foreground"
                >
                  {link.renderIcon()}
                </a>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-widest text-primary-foreground/50">Navegação</h4>
            <nav className="flex flex-col gap-2">
              {[
                { label: "Quem Somos", href: "/quem-somos" },
                { label: "Soluções", href: "/solucoes" },
                { label: "Produtos", href: "/produtos" },
                { label: "Segmentos", href: "/segmentos" },
                { label: "FAQ Técnico", href: "/faq" },
              ].map((link) => (
                <Link key={link.href} to={link.href} className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-widest text-primary-foreground/50">Soluções</h4>
            <nav className="flex flex-col gap-2">
              {[
                { label: "Avaliação de Base", href: "/solucoes#avaliacao-base" },
                { label: "Primer de Ancoragem", href: "/solucoes#primer" },
                { label: "Camada Flex", href: "/solucoes#camada-flex" },
                { label: "Lama Asfáltica", href: "/solucoes#lama-asfaltica" },
                { label: "Base Regularizadora", href: "/solucoes#base-regularizadora" },
                { label: "Resina Acrílica", href: "/solucoes#resina-acrilica" },
                { label: "Demarcatórias", href: "/solucoes#demarcatorias" },
                { label: "Recuperação de Quadras", href: "/solucoes#manutencao" },
              ].map((item) => (
                <Link key={item.href} to={item.href} className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-widest text-primary-foreground/50">Contato</h4>
            <div className="space-y-3">
              <a href="tel:+5517981390073" className="flex items-center gap-2 text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                <Phone className="h-4 w-4" />
                (17) 98139-0073
              </a>
              <a href="mailto:contato@indusport.com.br" className="flex items-center gap-2 text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                <Mail className="h-4 w-4" />
                contato@indusport.com.br
              </a>
              <div className="flex items-start gap-2 text-sm text-primary-foreground/70">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                São José do Rio Preto — SP
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-primary-foreground/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-primary-foreground/50">
            © {new Date().getFullYear()} Indusport — Tintas para Pisos Esportivos. Todos os direitos reservados.
          </p>
          <p className="text-xs text-primary-foreground/40 font-mono">
            Fábrica · Não executamos aplicação
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
